import { Injectable } from '@angular/core';
import { SearchItem } from '../models/searchItem';
import { Shortcuts } from '../models/Shortcuts';
import { ContextualHelpService } from './contextualHelpService';
import { HttpClient } from '@angular/common/http';
import { ContextualHelpModel } from '../models/contextualHelp';
import { cloneDeep } from 'lodash';
import { EndpointsService } from './endpoints.service';


@Injectable({
  providedIn: 'root'
})
export class SearchService {

  searchItems : SearchItem[] = [];
  expanded: boolean = true;

  constructor(public endpointService:EndpointsService,
    public contextualHelpService:ContextualHelpService,
    public http:HttpClient) {
   }

   getContextualHelpToolTips(){
    this.http.get(this.endpointService.contextualHelpGet,
      this.endpointService.httpOptions).subscribe((contextualHelp:ContextualHelpModel[])=>{
        if(contextualHelp == null || contextualHelp.length == 0)
          this.contextualHelpService.contextualHelpToolTips = [];
        else
          this.contextualHelpService.contextualHelpToolTips = contextualHelp;
        this.contextualHelpService.contextualHelpToolTips.sort((a,b)=> a.functionality.localeCompare(b.functionality))

        let toInsert: ContextualHelpModel[] = [];
        this.searchItems.forEach((searchItem:SearchItem)=>{
          let contextualHelpModel = contextualHelp.find(contextualHelpModel=>contextualHelpModel.functionality == searchItem.name);
          if(contextualHelpModel == null){
            let newContextHelp: ContextualHelpModel = new ContextualHelpModel();
            newContextHelp.isEnabled = true;
            newContextHelp.functionality = searchItem.name;
            newContextHelp.descriptionText = "";
            newContextHelp.link = "";
            newContextHelp.linkName = "";
            newContextHelp.selected = false;
            toInsert.push(newContextHelp);
          }
        })
        if(toInsert.length != 0){
          this.http.post(this.endpointService.contextualHelpUpdate,
            toInsert,
            this.endpointService.httpOptions
          ).subscribe((result:ContextualHelpModel[]) =>{
            this.contextualHelpService.contextualHelpToolTips = cloneDeep(result);
            this.contextualHelpService.contextualHelpToolTips.sort((a,b)=> a.functionality.localeCompare(b.functionality))
          })
        }
      })
    }
   getItemByShortcut(shortcut : Shortcuts) : SearchItem {
     let toReturn : SearchItem = new SearchItem();
     this.searchItems.forEach( item => {
       if(item.name == shortcut.sAction) {
         item.shortcutId = shortcut.id;
        toReturn = item;
       }
     });
     return toReturn;
   }

  unselectAllSearchItems() {
    this.searchItems.forEach(items => {
      items.selected = false;
    })
  }

  createNewSearchItem(name: string, action, opensFileExplorer?: boolean) {
    let item: SearchItem = new SearchItem()
    item.name = name;
    item.action = action;
    if (opensFileExplorer != null) {
      item.opensFileExplorer = opensFileExplorer;
    }
    this.searchItems.push(item);
  }

  deleteSearchItem(name: string){
    let i = this.searchItems.findIndex(item => item.name === name);
    if (i!= -1) this.searchItems.splice(i, 1)
  }
}
